import "@/assets/css/tailwind.css";
import "@/assets/css/main.css";
import "@/assets/style.css";
import "material-design-icons/iconfont/material-icons.css";
import "vue-select/dist/vue-select.css";
import "vue-datetime/dist/vue-datetime.css";
import vSelect from "vue-select";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import functions from "./plugins/functions";
import server from "./plugins/server";
import colors from "./plugins/colors";
import jwtService from "./plugins/jwt.service";
import moment from "moment";
import countries from "@/assets/data/countries.json";
import countriestimezones from "@/assets/data/country-timezones-currency.json";
import VueProgressBar from "vue-progressbar";
import KProgress from "k-progress";

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/fr";

import HighchartsVue from "highcharts-vue";

Vue.use(HighchartsVue, { tagName: "highcharts" });

Vue.component("k-progress", KProgress);
Vue.component("vue-slider", VueSlider);
Vue.component("date-picker", DatePicker);

import VueEllipseProgress from "vue-ellipse-progress";
Vue.use(VueEllipseProgress);

import Tabs from "vue-tabs-component";
Vue.use(Tabs);

import MultiRangeSlider from "multi-range-slider-vue";
import "../node_modules/multi-range-slider-vue/MultiRangeSliderBlack.css";
import "../node_modules/multi-range-slider-vue/MultiRangeSliderBarOnly.css";

Vue.component("MultiRangeSlider", MultiRangeSlider);

import components from "./components";
import VueSimpleAlert from "vue-simple-alert";
import VueApexCharts from "vue-apexcharts";

import _ from "lodash";
//loiding plugin
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Modal from "@burhanahmeed/vue-modal-2";
import VTooltip from "v-tooltip";
Vue.use(VTooltip);
Vue.use(Modal);
Vue.component("loading", Loading);
Vue.use(VueSimpleAlert);
Vue.component("apexchart", VueApexCharts);
const options = {
  canSuccess: true,
  show: false,
  color: "#4dc84b",
  position: "fixed",
  failedColor: "red",
  thickness: "4px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "top",
  inverse: false,
  autoFinish: true,
};

Vue.use(VueProgressBar, options);
//Vue.use(Swal);

import { Datetime } from "vue-datetime";
Vue.component("datetime-v2", Datetime);

components.forEach((c) => {
  Vue.component(c.name, c.component);
});
Vue.component("v-select", vSelect);

import VueBarcode from "@chenfengyuan/vue-barcode";
Vue.component("vue-barcode", VueBarcode);

Vue.prototype.$f = functions;
Vue.prototype.$server = server;
Vue.prototype.$colors = colors;
Vue.prototype.$jwtService = jwtService;
Vue.prototype.$me = server.me("users");
Vue.prototype.$moment = moment;
Vue.prototype.$countries = countries;
Vue.prototype.$countriestimezones = countriestimezones;

//jwtService.saveToken()
//jwtService.destroyToken()
//console.log(jwtService.getToken())

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  },
  created() {
    //  console.log('document.readyState----',document.readyState)
    //  if(document.readyState == 'loading')  store.dispatch("actionloadingpage",{loading:true});
    //     return false
    //     if (performance.navigation.type == 1 || performance.navigation.type == 0) {
    //         store.dispatch("actionloadingpage",{loading:true});
    //    }
  },
}).$mount("#app");
